import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-print-consent',
  templateUrl: './print-consent.component.html',
  styleUrls: ['./print-consent.component.scss'],
  standalone: false,
})
export class PrintConsentComponent implements OnInit {
  AutoIndex;
  concentForm;
  // drives the .finished marker the PDF renderer waits for
  loaded = false;

  OBEXAMS = [
    '1st',
    'NT',
    'Early',
    '2nd/3rd',
    'Weight Assessment',
    'Late',
    'Third Scan',
    'Specialized',
    'Fetal Echo',
  ];

  constructor(
    private route: ActivatedRoute,
    public http: HttpClient,
    private fb: FormBuilder,
    public translate: TranslateService,
    private changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.translate.use('he-IL');
    this.AutoIndex = this.route.snapshot.params['AutoIndex'];
    this.resetForm();
    this.loadData();
  }

  loadData() {
    this.http.get(`/api/consent/data/${this.AutoIndex}`).subscribe((data) => {
      for (let value in data[0]) {
        if (this.concentForm.controls[value]) {
          this.concentForm.controls[value].setValue(data[0][value]);
        }
      }
      this.loaded = true;
      this.changeDetector.detectChanges();

      const body = {
        AutoIndex: this.AutoIndex,
        value: 1,
      };
      this.http.post(`/api/consent/update-printed`, body).subscribe((data) => {});
    }, () => {
      this.loaded = true;
      this.changeDetector.detectChanges();
    });
  }

  resetForm() {
    this.concentForm = this.fb.group({
      AutoIndex: [''],
      PID: [''],
      UID: [''],
      GID: [''],
      PregID: [''],
      ExamID: [''],
      Opener: [''],
      Deleted: [''],
      DeletedBy: [''],
      ID: [''],
      First: [''],
      Last: [''],
      Phone: [''],
      CreationTime: [''],
      refferalDoc: [''],
      ExamType: [''],
      weekNum: [''],
      preformed: [''],
      docReason: [''],
      approved: [''],
      translated: [''],
      transName: [''],
      transRel: [''],
      appRel: [''],
      appName: [''],
      patSign: [''],
      patSignApproved: [''],
      appSign: [''],
      docSign: [''],
      printed: [''],
      DrNum: [''],
      ExpertNum: [''],
      NurseNum: [''],
      TechNum: [''],
    });
  }
}
